// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30hkx","col":"styles_col__vgTLI"};